<template>
    <div class="app-container bj-label-colon">
        <BjDivider right-fixed>{{ $t('route.BusinessUserfunConfig') }}
            <template slot="right">
                <template v-if="isSee">
                    <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
                    <el-button type="primary" @click="showLog">{{$t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
                </template>
                <template v-else>
                    <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
                    <el-button type="primary" @click="handleConfirm">{{ $t('saveText') }}</el-button>
                </template>
            </template>
        </BjDivider>
        <!-- label-width="360px" -->
        <el-form ref="form" :model="dataInfo" :rules="rules">
            <div style="width: 600px;" v-if="!$store.getters.cusId">
                <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode">
                    <BjSelectLov v-model="dataInfo.clientCode" :disabled="!!userId" :clearable="false"
                        :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" />
                </el-form-item>
            </div>
            <div v-for="(item, index) in dataInfo.features" :key="index">
                <BjDivider>{{ language === 'zh' ? item.featureNameCn : item.featureNameEn }}</BjDivider>
                <div class="flex-align flex-wrap" style="margin-left: 20px;">
                    <div v-for="(jitem, jindex) in item.options" :key="jindex" :style="jitem.lineBreak ? 'width:100%': 'width:45%'">
                        <div class="title" v-if="item.featureId==3">{{ language === 'zh' ? jitem.promptCn : jitem.promptEn }}</div>
                        <el-form-item>
                            <label slot="label" v-html="language === 'zh' ? jitem.optionNameCn : jitem.optionNameEn"></label>
                            <el-tooltip placement="top" v-if="jitem.describeCn">
                                <span slot="content">{{ language === 'zh' ? jitem.describeCn : jitem.describeEn }}</span>
                                <i class="el-icon-question" style="color:#4d08ed;position: relative;left:-5px;margin-right:20px;"></i>
                            </el-tooltip>
                            <el-radio v-for="(kitem, kindex) in jitem.defaultValues" :key="kindex"
                                v-model="jitem.optionValue" :label="kitem.valueCode">{{ language === 'zh' ?
                                    kitem.valueNameCn : kitem.valueNameEn
                                }}</el-radio>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import viewMiXin from '@/utils/view-mixin.js';
import { STATUS_YES_TRUE } from '@/utils/constants';
import { funConfigApi } from '@/api';
import { getLanguage } from '@/lang/index';
import orderLog from '@/utils/log.js';
export default {
    name: 'BusinessUserfunConfigInfo',
    mixins: [viewMiXin],
    data() {
        return {
            STATUS_YES_TRUE,
            dataInfo: {
                clientCode: this.$store.getters.userInfo.clientCode || null,
                isNew: this.$route.query.userId ? false:true
            },
            language: getLanguage(),
            rules: {
                clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            },
            isSee: this.$route.query.isSee || false,
            userId: this.$route.query.userId || null
        }
    },
    computed: {
        clientCodeList() {
            return this.$store.getters.clientCodeList;
        }
    },
    created() {
        if (this.userId) {
            this._viewConfig()
        } else {
            this._getConfigPage()
        }
    },
    methods: {
        showLog() {
            orderLog(
                this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
                    actionApi: funConfigApi.configurationLogInfo,
                    defaultQuery: {
                        clientCode: this.dataInfo.clientCode
                    },
                    columns: [
                        {
                            prop: 'operationBys',
                            label: 'BjDialogListConfig.Operator',
                        },
                        {
                            prop: 'operationDate',
                            label: 'BjDialogListConfig.Operationtime',
                        },
                        {
                            prop: 'operation',
                            label: 'BjDialogListConfig.Remarks',
                        },
                    ],
                }),
            );
        },
        _viewConfig() {
            funConfigApi.viewConfig({
                userId: this.userId,
                clientCode: this.$route.query.clientCode
            }).then(res => {
                res.features.forEach(item => {
                    item.options.forEach(jitem => {
                        this.$set(jitem, 'optionValue', jitem.userValue?.valueCode)
                    });
                })
                this.dataInfo = { ...this.dataInfo, ...res }
            })
        },
        _getConfigPage() {
            funConfigApi.getConfigPage().then(res => {
                res.features.forEach(item => {
                    item.options.forEach(jitem => {
                        jitem.optionValue = jitem.defaultValues.filter(kitem => kitem.isDefault)[0].valueCode
                    })
                });
                this.dataInfo = { ...this.dataInfo, ...res }
            })
        },
        handleConfirm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    funConfigApi.saveOrUpdateConfig(this.dataInfo).then((res) => {
                        if(!res.failed){
                            this.$message.success(this.$t('toast.operationSuccessText'));
                            this.complete('BusinessUserfunConfig')
                        }
                    })
                }
            });
        }
    }
}
</script>

<style scoped>
.title{
    height: 30px;
    line-height: 30px;
    font-size:14px;
    font-weight:bold;
}
::v-deep .el-form-item__label:after {
    content: ""!important;
}
</style>